import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import { Spinner } from '../Spinner';

interface CTAButtonProps {
  href?: string;
  target?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  disabledClassName?: string;
  isLoading?: boolean;
}

export const CTAButton: React.FC<PropsWithChildren<CTAButtonProps>> = ({
  children,
  href,
  target = '_blank',
  onClick,
  disabled = false,
  className,
  disabledClassName,
  isLoading = false,
}) => {
  const defaultDisabledClassName = 'mhg-alpha-btn-disabled';
  const defaultClassName = `mhg-alpha-btn-cta`;

  return (
    <>
      {!disabled ? (
        <a
          className={classNames(className ? className : defaultClassName, {
            '!cursor-default pointer-events-none': isLoading,
          })}
          href={href}
          target={target}
          rel="noreferrer"
          onClick={onClick}
        >
          {isLoading ? <Spinner /> : children}
        </a>
      ) : (
        <button
          type="button"
          className={
            disabledClassName ? disabledClassName : defaultDisabledClassName
          }
        >
          {children}
        </button>
      )}
    </>
  );
};
